import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

const groups = [
  ['Services', [['SME Solutions', '/services/sme'], ['Large Enterprise', '/services/large-enterprise'], ['Expert Consultancy', '/services/consultancy']]],
  ['Success Stories', [['SME Case Studies', '/success-stories/sme'], ['Enterprise Stories', '/success-stories/large-enterprise'], ['Consultancy Results', '/success-stories/consultancy']]],
  ['Company', [['About Us', '/about'], ['FAQ', '/faq'], ['Contact', '/contact']]],
];

export default function Footer() {
  return (
    <footer className='gpm-footer' id='gpm-footer'>
      <div className='gpm-shell'>
        <div className='gpm-footer-masthead'>
          <Link to='/' className='gpm-footer-brand'>
            <img src='/images/gpm-logo.png' alt='GPM Logo' width='60' height='60' />
            <span>Global Payroll<br /><em>Migration</em></span>
          </Link>
          <div className='gpm-footer-contact'>
            <a href='tel:02081784340'>020 8178 4340 <span aria-hidden='true'>↗</span></a>
            <a href='mailto:info@globalpayrollmigration.com'>info@globalpayrollmigration.com <span aria-hidden='true'>↗</span></a>
          </div>
        </div>
        <div className='gpm-footer-directory'>
          <nav className='gpm-footer-nav' aria-label='Footer'>
            {groups.map(([title, links]) => (
              <div className='gpm-footer-group' key={title}>
                <h2>{title}</h2>
                {links.map(([label, href]) => <Link key={href} to={href}>{label}</Link>)}
              </div>
            ))}
          </nav>
        </div>
        <div className='gpm-footer-end'>
          <div className='gpm-footer-legal'>
            <p>Copyright © {new Date().getFullYear()} Global Payroll Migration Ltd. All rights reserved.</p>
            <p>Registered in England &amp; Wales.</p>
          </div>
          <div className='gpm-footer-utilities'>
            <Link to='/admin/login'>Admin</Link>
            <a href='https://www.linkedin.com/company/global-payroll-migration/posts/?feedView=all' target='_blank' rel='noopener noreferrer'>LinkedIn <span aria-hidden='true'>↗</span></a>
            <a className='gpm-footer-top' href='#main-content' aria-label='Back to top'>↑</a>
          </div>
        </div>
        <p className='gpm-footer-credit'>Animated icons by <a href='https://lordicon.com/' target='_blank' rel='noreferrer'>Lordicon</a></p>
      </div>
    </footer>
  );
}
